import CraftCreate from 'src/components/CraftCreate';
import PassportForm from './PassportForm';

const PassportCreate = () => (
  <CraftCreate resource="passport" header="Create Passport" redirect={false} columns={12}>
    <PassportForm formType="create" />
  </CraftCreate>
);

export default PassportCreate;
